"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaiduVerificationRequest = void 0;
var BaiduVerificationRequest = /** @class */ (function () {
    function BaiduVerificationRequest() {
    }
    return BaiduVerificationRequest;
}());
exports.BaiduVerificationRequest = BaiduVerificationRequest;
;
//# sourceMappingURL=baiduVerification.request.js.map